import { render, staticRenderFns } from "./DictionaryType.vue?vue&type=template&id=0b59b002&"
import script from "./DictionaryType.vue?vue&type=script&lang=js&"
export * from "./DictionaryType.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports